<template>
  <div class="sp-breadcrumbs">
    <slot />
  </div>
</template>

<script setup>
import { props as breadcrumbsProps } from "./props.js";
defineProps(breadcrumbsProps);
</script>

<style>
:host {
  display: block;
}

::slotted(sp-breadcrumbs-item) {
  display: flex;
  flex-direction: row;
}

::slotted(sp-breadcrumbs-item:not([disabled]))::after {
  content: ">";
  display: inline-block;
  margin: 0 var(--sp-breadcrumbs-divider-space, 0.5ch);
}
</style>

<style scoped lang="scss">
.sp-breadcrumbs {
  display: flex;
}
</style>
